import "./GameShared.css";

export default function GameInterpretation({ interpretation }) {
  if (!interpretation) return null;

  return (
    <div className={`game-interpretation ${interpretation.level}`}>
      <h3>{interpretation.title}</h3>
      <p>{interpretation.text}</p>
      <small>
        Interpretación orientativa basada en el desempeño dentro del juego. No equivale a una prueba diagnóstica.
      </small>
    </div>
  );
}